import { ModelRow } from "@mcleod/core";
import { SecondaryFilterProps } from "@mcleod/dispatch";

interface Interface {
    id: string;
    name: string;
}

export class FuelTransactionTaskFilter {

    static buildVendorFilters(vendors: Interface[]): SecondaryFilterProps[] {
        return vendors.map(vendor => {
            const filter: SecondaryFilterProps = {
                id: `${vendor.id}`,
                caption: `${vendor.name}`,
                filter: (row: ModelRow) => {
                    return row.get("interface_id", "") == vendor.id;
                }
            }
            return filter;
        });
    }

}
